import type { ColDef, GetRowIdParams, GridOptions, ValueFormatterParams } from 'ag-grid-community';

import { TableHeaderWithTooltipIcon } from '~/components/common';
import { StockReleaseRequestQuantityInputCell } from '~/components/stock/StockCellRenderer';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseGoods } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 > 반출 요청 상품 테이블
 */
const getStockReleaseRegisterGoodsColumnDefs = () => {
  const gridOptions: GridOptions = {
    suppressScrollOnNewData: true,
    suppressRowVirtualisation: false,
    getRowId: (params: GetRowIdParams<TypeStockReleaseGoods>) => String(params.data.skuCode),
  };

  const columnDefs: ColDef<TypeStockReleaseGoods>[] = [
    {
      headerName: '',
      valueFormatter: () => '',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 44,
    },
    {
      field: 'skuName',
      headerName: '상품명',
      width: 240,
    },
    {
      field: 'temperatureTypeCodeObject.name',
      headerName: '보관 유형',
      width: 76,
    },
    {
      field: 'availableQuantity',
      headerName: '가용 재고',
      width: 76,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['availableQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },

    {
      field: 'availableRequestQuantity',
      headerName: '반출 요청 수량 (가용)',
      width: 155,
      cellRenderer: StockReleaseRequestQuantityInputCell,
      valueFormatter: () => '',
    },
    {
      field: 'defectiveQuantity',
      headerName: '불용 재고',
      width: 90,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['defectiveQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'defectiveRequestQuantity',
      headerName: '반출 요청 수량 (불용)',
      width: 155,
      cellRenderer: StockReleaseRequestQuantityInputCell,
      valueFormatter: () => '',
    },
    {
      field: 'holdingQuantity',
      headerName: '보류 재고',
      headerComponent: TableHeaderWithTooltipIcon,
      headerComponentParams: {
        tooltipDescription: '보류 재고는 반출 요청할 수 없습니다.',
        tooltipMaxWidth: '198px',
      },
      width: 96,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['holdingQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
      cellClass: 'overflow-visible',
    },
    {
      field: 'skuCode',
      headerName: 'SKU코드',
      width: 140,
    },
    {
      field: 'barcode',
      headerName: '상품 바코드',
      width: 140,
    },
  ];

  return { gridOptions, columnDefs };
};

export default getStockReleaseRegisterGoodsColumnDefs;
